import type { RealtimeEventEnvelope } from './types.js';

export function isRealtimeEventEnvelope(value: unknown): value is RealtimeEventEnvelope {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const envelope = value as Record<string, unknown>;
  return (
    typeof envelope.eventId === 'string' &&
    typeof envelope.seq === 'number' &&
    typeof envelope.type === 'string' &&
    typeof envelope.occurredAt === 'string' &&
    typeof envelope.correlationId === 'string' &&
    envelope.payload !== undefined
  );
}

/** At-least-once delivery — discard duplicate eventId */
export function isDuplicateEvent(eventId: string, seen: ReadonlySet<string>): boolean {
  return seen.has(eventId);
}

/** Monotonic seq per room — gap triggers REST resync (10-11 § Event Envelope) */
export function needsSeqResync(previousSeq: number | null, nextSeq: number): boolean {
  if (previousSeq === null) {
    return false;
  }
  return nextSeq !== previousSeq + 1;
}

export function trackEventId(eventId: string, seen: Set<string>): void {
  seen.add(eventId);
}
